<template>
  <v-container fluid>
    <v-row class="pt-5" v-if="profile">
      <v-col cols="3">
        <!-- <v-avatar size="65px" style="outline: solid;outline-width: 4px;outline-color: #E6BA95;"> -->
          <img
            v-if="profile.pictureUrl"
            style="border-color: #E6BA95;height:70px;border-radius: 40px;border-style: solid;border-width: 3px"
            alt="Avatar"
            :src="profile.pictureUrl"
          />
        <!-- </v-avatar> -->
      </v-col>
      <v-col cols="7">
        <span class="">
          <strong class="Raleway font16 headline1">สวัสดี, {{ profile.displayName }}</strong
          ><br />
          <div style="display:flex">
          <span class="font24 bold coin_icon mr-2 ml-0" v-if="member.currentPoint > 0"></span>
          <span class="font24 bold" style="display:flex" v-if="member.currentPoint > 0">{{ formatNumber(member.currentPoint) }}<p class="font16 pt-2 ml-2 headline1" style="text-align:center;margin-bottom:0px">คะแนน </p></span>
          </div>
          <div style="display:flex"
            v-if="member.currentPoint === 0"
          >
          <span class="font24 bold coin_icon mr-2 ml-0" v-if="member.currentPoint === 0"></span>
          <span class="font24 bold" style="display:flex" v-if="member.currentPoint === 0">{{ member.currentPoint }}<p class="font16 pt-2 ml-2 headline1" style="text-align:center;margin-bottom:0px">คะแนน </p></span>
          </div
          >
          <span class="font16 bold" v-if="member === null"
            >Coin จะแสดงเมื่อลูกค้าใช้บริการกับเราค่ะ</span
          >
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'HeaderProfile',
  data () {
    return {
      profile: null,
      member: []
    }
  },
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home/Test.vue